import Vue from 'vue'
import App from './App.vue'

// import './registerServiceWorker'
// // import router from './router'
// Vue.prototype.$ga = function(stuff){
//   //maybe add some defaults etc.
//   window.ga('send', stuff)
// }
Vue.config.productionTip = false

new Vue({
  // router,
  render: h => h(App)
}).$mount('#app')
